import Axios, {
  type AxiosRequestTransformer,
  type AxiosResponseTransformer,
} from 'axios';
import humps from 'humps';
import getConfig from 'lib/next-config-compat';
import queryString from 'query-string';

const { publicRuntimeConfig } = getConfig();

const ClientFactory = (authToken: string | null | undefined) => {
  const client = Axios.create({
    baseURL: `${publicRuntimeConfig.baseUrl}/api/`,
    withCredentials: true,
    headers: {
      ...(authToken ? { Authorization: `Bearer ${authToken}` } : {}),
      Accept: `application/json`,
    },
    paramsSerializer: params => {
      const data = humps.decamelizeKeys(params);

      return queryString.stringify(data, { arrayFormat: 'bracket' });
    },
    // Axios' defaults are a single transformer or an array of them, so they are
    // normalised to an array before ours is appended/prepended.
    transformResponse: [
      ...([] as AxiosResponseTransformer[]).concat(
        Axios.defaults.transformResponse ?? []
      ),
      data => humps.camelizeKeys(data),
    ],
    transformRequest: [
      data => humps.decamelizeKeys(data),
      ...([] as AxiosRequestTransformer[]).concat(
        Axios.defaults.transformRequest ?? []
      ),
    ],
  });

  return client;
};

export default ClientFactory;
